// disable any console logs in production
const isCypress = typeof Cypress !== 'undefined'

export const CLog = (...args) => {
  if (process.env.VUE_APP_ENV !== 'production' || isCypress) {
    console.log(...args)
  }
}

export const CDir = (...args) => {
  if (process.env.VUE_APP_ENV !== 'production' || isCypress) {
    console.dir(...args)
  }
}

export const CError = (...args) => {
  if (process.env.VUE_APP_ENV !== 'production' || isCypress) {
    console.error(...args)
  }
}

export const CGroup = (...args) => {
  if (process.env.VUE_APP_ENV !== 'production' || isCypress) {
    console.group(...args)
  }
}
export const CGroupEnd = (...args) => {
  if (process.env.VUE_APP_ENV !== 'production' || isCypress) {
    console.groupEnd(...args)
  }
}

export const CIGroup = (...args) => {
  if (process.env.VUE_APP_ENV !== 'production' || isCypress) {
    console.groupCollapsed(...args)
  }
}

export const CWarn = (...args) => {
  if (process.env.VUE_APP_ENV !== 'production' || isCypress) {
    console.warn(...args)
  }
}

export const CDebug = (...args) => {
  if (process.env.VUE_APP_ENV !== 'production' || isCypress) {
    console.debug(...args)
  }
}

export default {
  methods: {
    CDir,
    CError,
    CGroup,
    CGroupEnd,
    CIGroup,
    CLog,
    CWarn,
    CDebug,
  },
}
